import { FileText, Receipt, FileSearch, Target, Briefcase } from 'lucide-react';
export const dia = [
  { nameKey: 'navigation.sales', icon: FileText, zone: 'work', subItems: [
    { nameKey: 'nav.invoicing', pageName: 'Facturas', icon: FileText, permission: 'invoicing.view', descriptionKey: 'navigation.descriptions.invoicing', shortcuts: [
      { nameKey: 'nav.ticketbai', params: { tab: 'ticketbai' } },
      { nameKey: 'nav.verifactu', params: { tab: 'verifactu' } },
    ] },
    { nameKey: 'command.quotes_issued', pageName: 'Facturas', id: 'quotes-issued', badgeKey: false, path: '/facturas?tab=presupuestos',
      icon: FileSearch, permission: 'invoicing.view', descriptionKey: 'navigation.descriptions.quotes_issued' },
    { nameKey: 'nav.crm', pageName: 'CRMPipeline', icon: Target, permission: 'crm.view', beta: true, descriptionKey: 'navigation.descriptions.crm', shortcuts: [
      { nameKey: 'nav.activities', params: { tab: 'actividades' } },
      { nameKey: 'nav.segmentation', params: { tab: 'segmentacion' } },
    ] },
  ] },
  { nameKey: 'navigation.purchases', icon: Receipt, zone: 'work', subItems: [
    { nameKey: 'nav.expenses', pageName: 'Gastos', icon: Receipt, permission: 'accounting.view', descriptionKey: 'navigation.descriptions.expenses', shortcuts: [
      { nameKey: 'nav.ocr_scans', params: { tab: 'ocr' } },
    ] },
    { nameKey: 'nav.received_quotes', pageName: 'BandejaDocumentos', id: 'quotes-received', badgeKey: false,
      path: '/bandeja-documentos?tab=presupuestos', icon: FileSearch, descriptionKey: 'navigation.descriptions.quotes_received',
      showIf: ctx => ctx.hasPermission('ocr.review') || ctx.hasPermission('documents.view') },
    { nameKey: 'nav.suppliers', pageName: 'Contactos', id: 'contacts-suppliers', moduleKey: 'expenses', path: '/contactos?tab=proveedores',
      icon: Briefcase, descriptionKey: 'navigation.descriptions.suppliers' },
  ] },
];
export const nav = [...dia];
